import React, { useState, useEffect } from "react";
//import { Route, Switch } from 'react-router-dom';

import { auth } from "./component/fbase";
import "./App.css";
import LoginForm from "./LoginForm";
import JoinForm from "./members/JoinForm";
import Main from "./Main";
import Container from "react-bootstrap/Container";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const App = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [signedStatus, setSignedStatus] = useState("");
  //const [role,setRole] = useState(false);

  useEffect(() => {
    //console.log("useEffect App componentDidMount??");
    //console.log(auth);
    // auth.onAuthStateChanged : 사용자가 있을 경우 true, 없을경우 false;
    // onAuthStateChanged는 리스너 해제 함수를 반환합니다.
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        if (currentUser && currentUser.uid == user.uid) return; // 기존 값으면

        setCurrentUser(user);

        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        //var uid = user.uid;
        getUserRole(user, (role) => {
          console.log("role", role);
          if (role) {
            sessionStorage.setItem("userInfo", JSON.stringify(user));
            setSignedStatus("signedIn");
          } else {
            setSignedStatus("signedOut"); // 승인 대기 상태
          }
        });
      } else {
        setCurrentUser(user);

        // User is signed out
        // ...
        sessionStorage.removeItem("userInfo");
        setSignedStatus("signedOut");
      }
    });
    // 클린업(cleanup) 함수
    // 컴포넌트가 사라질 때(unmount) 등록했던 리스너를 제거합니다.
    return () => unsubscribe();
  }, []); // <-- 두 번째 인자로 빈 배열 '[]'을 꼭 추가해주세요.
  const getUserRole = async (user, fcn) => {
    try {
      const formData = new FormData();
      formData.append("uid", user.uid);
      formData.append("displayName", user.displayName);
      formData.append("email", user.email);
      formData.append("emailVerified", user.emailVerified);
      formData.append("photoURL", user.photoURL);
      let res = await fetch("https://work.wekoinonia.org/json/login.php", {
        method: "POST",
        body: formData,
        //headers: new Headers({
        //'Content-Type': 'application/json'
        //  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      });

      let json = await res.json(); //Promise 반환
      console.log("json:", json);
      if (json.userRole == "1") {
        if (json.user.confirm_yn == "Y") {
          fcn(true);
        } else {
          fcn(false);
        }
      } else {
        fcn(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  /*
  componentDidMount() {
       console.log("App componentDidMount");
      //console.log(auth);
       auth.onAuthStateChanged(user => {
         this.setState({ currentUser: user });
       })
  }
*/

  return (
    <>
      {signedStatus == "signedIn" ? (
        <DndProvider backend={HTML5Backend}>
          <Main />
        </DndProvider>
      ) : signedStatus == "signedOut" ? (
        <LoginForm />
      ) : (
        "loading..."
      )}
    </>
  );
};

export default App;
